import styled, { css } from "styled-components"
import { em } from "polished"

import { paragraphSmallStyles } from "./paragraph"

const figureStyles = css`
  &.--with-background {
    padding: ${em(40)};
    background-color: ${({ theme }) => theme.colors.cream};

    @media ${({ theme }) => theme.mq.mediumDown} {
      padding: ${em(20)};
    }
  }

  figcaption {
    ${paragraphSmallStyles}

    margin-top: ${em(10)};
    color: ${({ theme }) => theme.colors.metallic};
  }
`

const Figure = styled.figure`
  ${figureStyles}
`

export { Figure, figureStyles }
